<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{header}}</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" >
  <ng-container  [ngTemplateOutlet]="staticElement"></ng-container>
</div>
